<template>
  <main role="main" class="section">
    <div class="container text-center">
      <h1 class="text-uppercase mb-3 d-none">{{$t('Upload.UplaodTitle')}}</h1>
      <p class="d-none">{{$t('Upload.UplaodDesc')}}</p>
      <section class="wrapper">
        <component
          :is="WidgetComponent"
          :campaign-id="$t('CampaignID')"
          :referral-source="referralSource"
        ></component>
      </section>
    </div>
  </main>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
  computed: {
    referralSource() {
      return this.$route.path.toLowerCase() === '/amoe' ? 'amoe' : 'standard';
    },
  },
};
</script>
